<style scoped lang="scss" type="text/scss">
    .terms-container {
        .text-container {
            max-height: 35rem;
            overflow: scroll;
            margin-bottom: 1rem;

            h3 {
                margin: .5rem 0;
            }
        }
    }
</style>

<template>
    <el-dialog
            class="terms-container"
            :title="'全国大学生机器人大赛 '+ siteName + ' 参赛条款'"
            :visible="visible"
            :close-on-click-modal="false"
            width="70%">
        <div class="text-container" ref="globalTermsTextContainer">
            <p>尊敬的参赛队：</p>
            <p>您好</p>

            <p>欢迎报名参加全国大学生机器人大赛{{ siteName }}（以下简称{{ siteName }}）。请您仔细阅读以下报名参赛的相关条款，当您通过报名系统（网址：https://data.cn{{ siteName }}.net/）向{{ siteName }}运营方提交报名材料，即表明您已阅读、理解并接受以下参赛条款。</p>

            <p>注意：</p>

            <p>1.{{ siteName }}运营方保留核实每个参赛者（含参赛队指导老师）的参赛资格的权利，并有权拒绝任何不符合参赛资格要求的参赛者参加比赛及/或免除其参赛资格。</p>

            <p>2.若您不理解或不接受本参赛条款中的任何内容，请立即离开本网页并终止报名。</p>

            <p>3.本参赛条款所称参赛者，指通过报名系统向{{ siteName }}运营方提交报名材料并报名成功，参与{{ siteName }}赛事的人员，包括参赛队队员、队长以及参赛队指导老师等全部参赛人员。</p>

            <h3>一、 安全参赛承诺</h3>
            <p>安全是{{ siteName }}可持续发展的重要内容之一，所设计的机器人的安全性对于比赛的安全是最重要的事。作为机器人的设计者，参赛队对其机器人的安全性负有责任。参赛者应与{{ siteName }}运营方密切合作，以确保比赛最大限度的安全，为保护参赛队伍及{{ siteName }}运营方及各参与单位的合法权益，同时保证{{ siteName }}的顺利进行，根据相关法律法规，报名参赛者（含参赛队指导老师）郑重承诺如下：</p>

            <p>1. 参赛者在申请参加比赛前，必须充分注意其机器人的安全性。</p>

            <p>2. 保证参赛者具有完全民事行为能力并且确保具备独立制造、操控机器人的能力，并保证制造之前仔细阅读{{ siteName }}的报名规则、竞赛规则、安全指南、{{ siteName }}运营方相关规定等文件。</p>

            <p>3. 在视频检查和试运行过程中，所设计的机器人是否满足安全要求必须是可以观察的，积极配合{{ siteName }}运营方的安全检查。</p>

            <p>4. 请在机器人上安装硬件急停按钮。队员在比赛和试运行期间必须穿胶底鞋、戴头盔和安全防护镜。</p>

            <p>5. 在参赛的任何时段，参赛者会充分注意安全问题，参赛队指导教师应负起安全指导和监督的责任。</p>

            <p>6. 保证不使用被视为危险的任何能源，包括但不限于任何燃油驱动的发动机、爆炸物以及含能化学材料等。</p>

            <p>7. 在练习及比赛中所发生的，因机器人故障、机器人状态失控等意外情况所造成的一切事故责任以及相应损失均由参赛队自行承担。</p>

            <p>8. 赛事期间，所有机器人的制作、测试、使用等行为不会给己方队员及对方队员、裁判、工作人员、观众、设备和比赛场地造成伤害。</p>

            <p>9. 严格遵守国家法律法规及相关规定，保证只将参赛机器人用于{{ siteName }}赛事及相关活动，不用于其他非法用途。</p>

            <h3>二、肖像权</h3>
            <p>报名参赛者（含参赛队指导老师）同意且不可撤销的授予{{ siteName }}运营方北京深蓝智能机器人研究院（本条中简称为“被授权人”）如下权利：</p>

            <p>1. 被授权人有权拍摄、制作包含参赛者个人肖像的图片、照片或视频，被授权人享有永久无偿使用参赛者个人肖像的权利，上述使用权包括但不限于对个人肖像及含有个人肖像作品的发表、复制、修改、剪辑、技术处理、发行、展览、放映、信息网络传播、摄制、改编、汇编等。</p>

            <p>2.被授权人使用参赛者个人肖像的目的仅限于与{{ siteName }}赛事相关的商业或非商业目的（包括但不限于产品（商品）外包装、宣传手册、网站页面、户外展览、图书报刊及媒体广告等）。</p>

            <p>3.被授权人有权许可第三方使用参赛者个人肖像，包括但不限于：被授权人有权许可第三方拍摄、制作包含参赛者个人肖像的图片、照片或视频，并许可第三方使用参赛者个人肖像，包括但不限于对参赛者个人肖像及含有个人肖像作品的发表、复制、修改、剪辑、技术处理、发行、展览、放映、信息网络传播、摄制、改编、汇编等。</p>

            <p>4.报名参赛者同意在使用本人肖像时一并同时展示本人的真实姓名。</p>


            <h3>三、 知识产权</h3>
            <p>{{ siteName }}赛事运营方鼓励并倡导技术创新以及技术开源，并尊重参赛队的知识产权。参赛队伍比赛中开发的所有知识产权均归所在队伍所有或由设计人员自行约定。</p>

            <p>参赛队伍提交的作品，包括但不限于文档、设计、程序等资料，{{ siteName }}赛事运营方有权进行开源分享、出版、宣传等无偿使用。</p>

            <p>参赛者在研发制作机器人过程不得侵犯他人知识产权，如发生知识产权纠纷，后果由侵权方自行承担全部责任。{{ siteName }}仅为比赛平台，{{ siteName }}运营方不参与处理队伍内部成员之间的知识产权纠纷，参赛队伍须妥善处理本队内部学校成员、企业成员及其他身份的成员之间对知识产权的所有关系。</p>

            <h3>四、 隐私权</h3>
            <p>1. 当报名参加{{ siteName }}时，{{ siteName }}运营方将采集报名参赛者（含参赛队指导老师）个人的姓名、身份证号码、性别、联络方式（包括但不限于电话、电邮及通讯地址等）、所在学校、就读专业以及其他可以直接或间接识别个人身份信息。</p>
            <p>2. 为完成赛事组织与管理相关工作，{{ siteName }}运营方将在{{ siteName }}中与各参与单位、合作单位、赞助单位共享、使用队内全体参赛者的个人信息。</p>

            <p>3. 当政府部门、司法机关等依照法定程序要求披露个人信息时，{{ siteName }}运营方将根据执法单位之要求或为公共安全之目的提供个人信息。在此情况下之任何披露均免责。</p>

            <h3>五、 报名参赛者（含参赛队指导老师）承诺：</h3>

            <p>本人在通过报名系统向{{ siteName }}运营方北京深蓝智能机器人研究院提交报名材料正式报名参加全国大学生机器人大赛 {{ siteName }}前，已充分阅读、知悉并同意本参赛条款的全部内容，并仔细阅读了加粗加黑的重点提示部分内容，同意报名全国大学生机器人大赛{{ siteName }}赛事。</p>
        </div>
        <div>
            <el-button type="primary" plain @click="confirm()" :disabled="!scrollBottomed">
                已知晓并同意
                <span v-if="!scrollBottomed">（请看完上述内容）</span>
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: '',
        components: {},
        computed: {
            siteName () {
                return process.env.VUE_APP_SITE_NAME;
            }
        },
        watch: {},
        data () {
            return {
                visible: false,
                scrollBottomed: false
            };
        },
        methods: {
            confirm () {
                // localStorage.setItem('main-terms-confirmed', 'true')
                this.visible = false;
            },
            scrollTrigger() {
                const globalTermsTextContainerRef = this.$refs.globalTermsTextContainer;
                const scrollTop = globalTermsTextContainerRef.scrollTop;
                const scrollHeight = globalTermsTextContainerRef.scrollHeight;
                const offsetHeight = globalTermsTextContainerRef.offsetHeight;
                if (offsetHeight + scrollTop >= scrollHeight ) {
                    this.scrollBottomed = true
                }
            }
        },
        mounted () {
            // const cached = localStorage.getItem('main-terms-confirmed');
            // if (cached && cached === 'true') return;

            this.visible = true;

            this.$nextTick(() => {
                // console.dir(this.$refs);
                // console.log(this.$refs.globalTermsTextContainer);

                this.$refs.globalTermsTextContainer.addEventListener('scroll', this.scrollTrigger);
                this.scrollTrigger();
            });
        },
        beforeDestroy () {
            this.$refs.globalTermsTextContainer.removeEventListener('scroll', this.scrollTrigger);
        }
    };
</script>
